export enum ContentType {
  movie = 'MOVIE',
  show = 'SHOW',
  sport = 'SPORT',
  season = 'SEASON',
}
